import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TextField } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withState from 'recompose/withState';
import CancelButton from '../atoms/CancelButton';
// import ChangeButton from '../atoms/ChangeButton';
import ValidationText from '../atoms/ValidationText';
import ProgressDialog from './ProgressDialog';
import { changesystemInvoiceRateData } from '../../libs/apis/SystemApi';
import OkButton from '../atoms/OkButton';

const styles = theme => ({
  textField: {
    minWidth: 200,
    width: 200,
    float: 'left'
  },
  text: {
    float: 'left',
    marginTop: '26px'
  },
  error: {
    width: '100%',
    float: 'left'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  }
});

const enhance = compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  withState('validError', 'setValidError', ''),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', '')
);

const Main = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    message,
    setMessage,
    priority,
    setPriority,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    connectSystemId,
    validError,
    setValidError,
    oldPriority,
    setOldPriority
  }) => {
    function showErrorMessage() {
      setLoading(false);
      setMessage('優先度の設定に失敗しました。');
    }

    function progressOkAction() {
      updateOpenProgress(false);
      updateOpenChange(false);
      setPriority(oldPriority);
    }

    function cancelAction() {
      setPriority(oldPriority);
      setValidError('');
      updateOpenChange(false);
    }

    function validPriority() {
      const num = priority ? parseInt(priority, 0) : -1;
      if (num > 100 || num < 0) {
        return false;
      }
      return true;
    }

    function changeAction() {
      if (!validPriority()) {
        setValidError('0から100までご入力ください。');
        return;
      }
      setValidError('');
      updateOpenProgress(true);
      setLoading(true);
      changesystemInvoiceRateData(connectSystemId, {
        systemInvoiceRate: priority
      })
        .then(response => {
          if (response.status === 200) {
            setMessage('手数料率を設定しました。');
            setOldPriority(priority);
            setLoading(false);
          } else {
            showErrorMessage();
          }
        })
        .catch(() => {
          showErrorMessage();
        });
    }

    return (
      <>
        <Dialog
          open={openChange}
          onClose={() => {
            updateOpenChange(false);
            setPriority(oldPriority);
            setValidError('');
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Typography component="p" className={classes.description}>
              手数料率設定
            </Typography>
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <div className={classes.input}>
                    <TextField
                      required
                      // label="メールアドレス"
                      // placeholder="メールアドレス"
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const value = e.target.value.replace(/[^\d]/, '') || '';
                        setPriority(value);
                      }}
                      inputProps={{
                        maxLength: 1000
                      }}
                      value={priority}
                    />
                    <Typography className={classes.text}>%</Typography>
                  </div>
                  <div className={classes.error}>
                    <ValidationText message={validError} />
                  </div>
                </TableCell>
              </TableRow>
            </Table>
          </DialogContent>
          <DialogActions>
            <CancelButton onClickAction={cancelAction} color="default" />
            <OkButton onClickAction={changeAction} />
          </DialogActions>
        </Dialog>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
